import React from "react";

export const validateAddItem = (d = {}) => {
    const errors = [
        ["name", requiredText(d.name, "El nombre es obligatorio")],
        ["categoryId", String(d.categoryId) !== "0" ? "" : "Selecciona una categoría"],
        ["quantity", requiredText(d.quantity, "La cantidad es obligatoria")],
        ["locationId", String(d.locationId) !== "0" ? "" : "Selecciona una ubicación"],
        ["unitOfWeightMeasurement", !d.unitOfWeightMeasurement ? "Selecciona una unidad" : ""],
    ];
    return packErrors(errors);
};

// Valida que un string no esté vacío (después de trim)
export const requiredText = (v = "", msg = "Este campo es requerido") =>
    String(v).trim() ? "" : msg;

// Helper: empaqueta errores omitiendo vacíos
export const packErrors = (entries) =>
    Object.fromEntries(entries.filter(([, val]) => Boolean(val)));

export const RequiredLabel = ({ children, required }) =>
    React.createElement(
        "span",
        { className: "fw-bold" },
        children,
        " ",
        required && React.createElement("span", { className: "text-danger" }, "*")
    );